<template>
  <div class="common-style-config">
    <el-collapse>
      <el-form size="mini" label-position="top" :model="selectItem.styleConfig" label-width="100px">
        <el-collapse-item title="标题与卡片">
          <style-sub-item title="标题">
            <el-form-item>
              <el-checkbox v-model="selectItem.styleConfig.commongConfig.showTitle">显示主标题</el-checkbox>
              <div class="chart-form-item-warp">
                <span class="jz-chart-title-label">标题</span>
                <el-input v-model="selectItem.name" />
              </div>
            </el-form-item>
          </style-sub-item>
          <style-sub-item title="备注">
            <el-form-item>
              <el-checkbox v-model="selectItem.styleConfig.commongConfig.showRemark">显示备注</el-checkbox>
              <div class="chart-form-item-warp">
                <span class="jz-chart-title-label">备注</span>
                <el-input v-model="selectItem.styleConfig.commongConfig.remark" />
              </div>
              <div class="chart-form-item-warp">
                <span class="jz-chart-title-label">位置</span>
                <el-radio-group v-model="selectItem.styleConfig.commongConfig.remarkPosition">
                  <el-radio :label="remarkPositionMap.title">紧跟标题</el-radio>
                  <el-radio :label="remarkPositionMap.top">图表上方</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </style-sub-item>
          <style-sub-item title="组件容器">
            <el-form-item>
              <div class="chart-form-item-warp">
                <el-checkbox style="margin-right: 10px;"
                  v-model="selectItem.styleConfig.commongConfig.customBackgroundColor">自定义背景填充</el-checkbox>
                <el-color-picker v-model="selectItem.styleConfig.commongConfig.backgroundColor"
                  show-alpha></el-color-picker>
              </div>
            </el-form-item>
          </style-sub-item>
        </el-collapse-item>
        <component :is="selectItem.styleComp.type" :selectItem="selectItem"></component>
      </el-form>
    </el-collapse>
  </div>
</template>
<script>
import styleSubItem from '../base/styleSubItem.vue'
import cTableStyle from './cTableStyle.vue'
import cLineStyle from './cLineStyle.vue'
import cIndicatorStyle from './cIndicatorStyle.vue'
import cColumnStyle from './cColumnStyle.vue'
import cPieStyle from './cPieStyle.vue'
import cGaugeStyle from './cGaugeStyle.vue'
import { remarkPositionMap } from '../../utils/panelConf'

export default {
  name: 'commonStyleConfig',
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      remarkPositionMap
    }
  },
  components: {
    styleSubItem,
    cTableStyle,
    cLineStyle,
    cIndicatorStyle,
    cColumnStyle,
    cPieStyle,
    cGaugeStyle
  }
}
</script>
<style lang="less">
:root {
  --color-primary: #165DFF;
  --bi-jz-sub-color: hsla(0, 0%, 100%, 0.5);
  --bi-jz-bg-color: #fff;
  --bi-jz-font-color: rgba(0, 0, 0, 0.65);
  --bi-jz-border-color: rgba(0, 0, 0, 0.12);
  --bi-jz-input-bg-color:#fff;
  --bi-jz-input-border-color:var(--bi-jz-border-color);
  --bi-jz-input-color:#606266;
  --bi-jz-primary-color:#2e74ff;
}
// :root dark
// background-color: #2c2c2c !important;
//     border-color: #4c4d4f !important;
//     color: #fff !important;
</style>
<style lang="less" scoped>
/deep/ .chart-form-item-warp {
  display: flex;
  align-items: center;
  margin-top: 6px;

  .jz-chart-title-label {
    width: 80px;
    margin-right: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1;
    text-align: left;
    font-style: normal;
    font-family: Microsoft YaHei UI;
    white-space: nowrap;
    flex-shrink: 0;
  }
}

/deep/ .common-style-config {
  width: 100%;
  height: 100%;
}

/deep/ .el-form-item__content {
  color: var(--bi-jz-sub-color) !important;
  line-height: 1;
}

/deep/ .el-form-item__label {
  margin-bottom: 8px;
  line-height: 1;
  padding-bottom: 0;
  color: var(--bi-jz-sub-color) !important;
}

/deep/ .el-radio {
  margin-right: 6px;
}

/deep/ .el-collapse-item__header {
  direction: rtl;
  padding: 0 12px;
  display: block;
  text-align: left;
  background-color: var(--bi-jz-bg-color);
  color: var(--bi-jz-font-color);
  border-color: var(--bi-jz-border-color);
}

/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 0;
}

/deep/ .el-collapse-item__header.is-active {
  border-color: transparent
}

/deep/ .el-collapse {
  border-top-color: transparent;
  border-bottom-color: transparent
}

/deep/ .el-collapse-item__content {
  padding-bottom: 12px;
}

/deep/ .el-collapse-item__wrap {
  background-color: var(--bi-jz-bg-color);
  border-bottom-color: var(--bi-jz-border-color);
  padding: 0 12px;

  * {
    color: var(--bi-jz-font-color);
  }
}

</style>